import { RouteComponentProps } from "@reach/router";
import React from "react";
import ActivationStep4ActivationHelpBattery from "../../Step4Activation/Step4ActivationHelpBattery";

type Props = RouteComponentProps<{ podKeyOrSerialNumber: string }>;

export default function ActivationStep5TroubleShootBattery(props: Props) {
  return <ActivationStep4ActivationHelpBattery {...props} />;
}
